export default __webpack_public_path__ + "static/media/S0100.Fig6.9-NEW.1657890600000.f978b465.jpg";